import { drawBox, drawLine, drawPoint } from "../draw/draw";
import {
  SUBTRACTION,
  ADDITION,
  REVERSE_SUBTRACTION,
  INTERSECTION,
  DIFFERENCE,
  HOLLOW_SUBTRACTION,
  HOLLOW_INTERSECTION,
  Brush,
  Evaluator,
} from "three-bvh-csg";
import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";
import { BoxGeometry } from "three";
import { getFacesArea } from "@/components/geometry/geometryLoader";

const mainColor = "#00FFFF";
const opposingColor = "#00FF00";
const csgEvaluator = new Evaluator();

let tempMeshes = [];

function calculateAnchorAreas(meshes1, meshes2) {
  let mbox1 = getMeshesBox(meshes1.map((m) => m.rootAnchorMesh));
  let mbox2 = getMeshesBox(meshes2.map((m) => m.rootAnchorMesh));
  let mp1 = new THREE.Vector3(mbox1.center.x, mbox1.center.y, mbox1.center.z);
  let mp2 = new THREE.Vector3(mbox2.center.x, mbox2.center.y, mbox2.center.z);
  let centerPoint = new THREE.Vector3(
    (mp1.x + mp2.x) / 2,
    (mp1.y + mp2.y) / 2,
    (mp1.z + mp2.z) / 2
  );

  let allMeshes = meshes1.concat(meshes2);
  allMeshes.forEach((mesh) => {
    if (mesh.rootFaces) {
      let toPoint = meshes1.includes(mesh) ? mp1 : mp2;
      let dir = new THREE.Vector3();
      dir.subVectors(centerPoint, toPoint);
      let filtered = filterFacesByDirection(mesh.rootFaces, dir);
      let anchorArea = 0;
      filtered.forEach((face) => (anchorArea += face.area));
      mesh.anchorArea = +anchorArea.toFixed(1);
    }
  });
  return centerPoint;
}

function getMeshesBox(meshes) {
  let min = { x: 100000, y: 100000, z: 100000 };
  let max = { x: -10000, y: -100000, z: -100000 };
  let meshesBox = { min, max };
  meshes.forEach(function (mesh) {
    let geometry = mesh.geometry;
    if (!geometry.boundingBox) geometry.computeBoundingBox();
    let toothBox = geometry.boundingBox;
    toothBox = offsetBox(
      toothBox,
      mesh.position.x,
      mesh.position.y,
      mesh.position.z
    );

    if (toothBox.min.x < meshesBox.min.x) {
      meshesBox.min.x = toothBox.min.x;
    }
    if (toothBox.min.y < meshesBox.min.y) {
      meshesBox.min.y = toothBox.min.y;
    }
    if (toothBox.min.z < meshesBox.min.z) {
      meshesBox.min.z = toothBox.min.z;
    }
    if (toothBox.max.x > meshesBox.max.x) {
      meshesBox.max.x = toothBox.max.x;
    }
    if (toothBox.max.y > meshesBox.max.y) {
      meshesBox.max.y = toothBox.max.y;
    }
    if (toothBox.max.z > meshesBox.max.z) {
      meshesBox.max.z = toothBox.max.z;
    }
  });
  meshesBox = offsetBox(meshesBox, 0, 0, 0, 0);
  return meshesBox;
}

function debugAnchorageResult(
  meshes1,
  meshes2,
  allAnchorageTeeth,
  mainColor,
  opposingColor
) {
  $("#anchorageWizard").modal("hide");

  tempMeshes.forEach((tmesh) => {
    viewer.scene.remove(tmesh);
  });

  let axesHelper = new THREE.AxesHelper(80);
  tempMeshes = [axesHelper];
  // viewer.scene.add(axesHelper);

  let mbox1 = getMeshesBox(meshes1.map((m) => m.rootAnchorMesh));
  let mbox2 = getMeshesBox(meshes2.map((m) => m.rootAnchorMesh));
  let mp1 = new THREE.Vector3(mbox1.center.x, mbox1.center.y, mbox1.center.z);
  let mp2 = new THREE.Vector3(mbox2.center.x, mbox2.center.y, mbox2.center.z);
  tempMeshes.push(drawLine(mp1, mp2, 0xff0000, viewer));
  let centerPoint = new THREE.Vector3(
    (mp1.x + mp2.x) / 2,
    (mp1.y + mp2.y) / 2,
    (mp1.z + mp2.z) / 2
  );
  tempMeshes.push(drawPoint(centerPoint, 0xff0000, false, 1, viewer));
  // tempMeshes.push(drawPoint(vcenter, 0xffffff, false, 1, viewer));
  // console.log("debugAnchorageResult", centerPoint, vcenter);
  // tempMeshes.push(drawBox(meshesBox, 0xff0000, viewer));
  // tempMeshes.push(drawBox(mbox1, mainColor, viewer));
  // tempMeshes.push(drawBox(mbox2, opposingColor, viewer));

  vueApp.allItems.forEach((item) => {
    item.isVisible = allAnchorageTeeth.includes(item);
    itemVisibilityChanged(item, item.color, 1); // 0.5
    if (item.isVisible) {
      let mesh = viewer.get_model_mesh(item.id);
      if (mesh.rootFaces) {
        let color = meshes1.includes(mesh) ? mainColor : opposingColor;
        let facesMesh = facesToMesh(mesh.rootFaces, 0x000001);
        facesMesh.position.copy(mesh.rootCenter);
        // viewer.scene.add(facesMesh);
        tempMeshes.push(facesMesh);

        let toPoint = meshes1.includes(mesh) ? mp1 : mp2;
        let dir = new THREE.Vector3();
        dir.subVectors(centerPoint, toPoint);

        // tempMeshes.push(drawPoint(dir, color));

        let filtered = filterFacesByDirection(mesh.rootFaces, dir);
        let filteredMesh = facesToMesh(filtered, color);
        filteredMesh.position.copy(mesh.rootCenter);
        viewer.scene.add(filteredMesh);
        tempMeshes.push(filteredMesh);
      }
    }
  });

  vueApp.lookAtPoint(centerPoint);

  $("#anchorageWizard").modal("hide");
}

function generateRootCrownMeshes() {
  console.log("generateRootCrownMeshes");
  csgEvaluator.attributes = ["position", "normal"];
  csgEvaluator.useGroups = false;

  let maxillaBrush = null;
  let maxilla = vueApp.bones.find((b) => b.isMaxilla);
  if (maxilla) {
    let maxillaMesh = viewer.get_model_mesh(maxilla.id);
    let pos = maxillaMesh.position;
    let maxillaGeometry = maxillaMesh.closedGeometry
      ? maxillaMesh.closedGeometry
      : maxillaMesh.geometry;
    if (maxillaMesh.closedGeometry) {
      let box = offsetBox(
        maxillaMesh.closedGeometry.baseBox,
        -defaultXOffset,
        -defaultYOffset,
        -defaultZOffset
      );
      pos = new THREE.Vector3(box.center.x, box.center.y, box.center.z);
    }
    maxillaGeometry = toBufferGeometry(maxillaGeometry)
      .clone()
      .translate(pos.x, pos.y, pos.z);
    // maxillaGeometry = BufferGeometryUtils.mergeGeometries(
    //   [maxillaGeometry],
    //   false
    // );
    maxillaGeometry.computeVertexNormals();
    maxillaBrush = new Brush(maxillaGeometry);
    maxillaBrush.updateMatrixWorld();
  }

  let mandibulaBrush = null;
  let mandibula = vueApp.bones.find((b) => !b.isMaxilla);
  if (mandibula) {
    let mandibulaMesh = viewer.get_model_mesh(mandibula.id);
    let pos = mandibulaMesh.position;
    let mandibulaGeometry = mandibulaMesh.closedGeometry
      ? mandibulaMesh.closedGeometry
      : mandibulaMesh.geometry;
    if (mandibulaMesh.closedGeometry) {
      let box = offsetBox(
        mandibulaMesh.closedGeometry.baseBox,
        -defaultXOffset,
        -defaultYOffset,
        -defaultZOffset
      );
      pos = new THREE.Vector3(box.center.x, box.center.y, box.center.z);
    }
    mandibulaGeometry = toBufferGeometry(mandibulaGeometry)
      .clone()
      .translate(pos.x, pos.y, pos.z);
    // mandibulaGeometry = BufferGeometryUtils.mergeGeometries(
    //   [mandibulaGeometry],
    //   false
    // );
    mandibulaGeometry.computeVertexNormals();
    mandibulaBrush = new Brush(mandibulaGeometry);
    mandibulaBrush.updateMatrixWorld();
  }

  vueApp.allTeeth.forEach((tooth, index) => {
    // if (index != 0) return;
    let toothMesh = viewer.get_model_mesh(tooth.id);
    let toothPosition = toothMesh.position;
    let meshGeometry = toothMesh.cbctGeometry
      ? toothMesh.cbctGeometry
      : toothMesh.geometry;
    let toothGeometry = toBufferGeometry(meshGeometry)
      .clone()
      .translate(toothPosition.x, toothPosition.y, toothPosition.z);
    let toothBrush = new Brush(toothGeometry);
    toothBrush.updateMatrixWorld();

    let bone = tooth.isUpper ? maxilla : mandibula;
    let boneBrush = tooth.isUpper ? maxillaBrush : mandibulaBrush;
    // let cutBrush = getToothCutBrush(tooth, toothMesh, bone, boneBrush);
    let cutBrush = vueApp.hasClosedBones
      ? boneBrush
      : getToothCutBrush2(tooth, toothMesh, bone, boneBrush);

    if (cutBrush) {
      let rootMesh = csgEvaluator.evaluate(
        toothBrush,
        cutBrush,
        HOLLOW_INTERSECTION
      );
      rootMesh.material = toothMesh.originalMaterial.clone();
      rootMesh.material.color = new THREE.Color(
        tooth.isUpper ? opposingColor : mainColor
      );
      //  new THREE.MeshPhongMaterial({
      //   color: tooth.isUpper ? opposingColor : mainColor,
      //   flatShading: false,
      //   specular: 0x050505,
      //   shininess: 200,
      //   side: 2,
      // });
      let rootGeometry = rootMesh.geometry.clone();
      rootGeometry.computeBoundingBox();
      let center = offsetBox(rootGeometry.boundingBox).center;
      rootGeometry.center();

      toothMesh.rootCenter = new THREE.Vector3(center.x, center.y, center.z);
      toothMesh.rootOffset = new THREE.Vector3(
        center.x - toothPosition.x,
        center.y - toothPosition.y,
        center.z - toothPosition.z
      );
      toothMesh.rootFaces = getFaces(rootGeometry);
      toothMesh.rootGeometry = rootGeometry.translate(toothMesh.rootOffset);
      toothMesh.rootArea = getFacesArea(rootGeometry);

      toothMesh.rootAnchorMesh = rootMesh;
      toothMesh.boneBrush = boneBrush;

      let crownMesh = csgEvaluator.evaluate(
        toothBrush,
        cutBrush,
        HOLLOW_SUBTRACTION
      );
      crownMesh.material = toothMesh.originalMaterial; //.clone();
      let mergedGeometry = BufferGeometryUtils.mergeGeometries(
        [crownMesh.geometry, rootMesh.geometry],
        true
      );
      mergedGeometry.center();

      const materials = [crownMesh.material, rootMesh.material];
      toothMesh.geometry = toothMesh.cbctGeometry =
        fromBufferGeometry(mergedGeometry);
      toothMesh.rootCrownMaterials = materials;

      if (toothMesh.stitchedGeometry) {
        toothGeometry = toBufferGeometry(toothMesh.stitchedGeometry)
          .clone()
          .translate(toothPosition.x, toothPosition.y, toothPosition.z);
        toothBrush = new Brush(toothGeometry);
        toothBrush.updateMatrixWorld();

        rootMesh = csgEvaluator.evaluate(
          toothBrush,
          cutBrush,
          HOLLOW_INTERSECTION
        );
        crownMesh = csgEvaluator.evaluate(
          toothBrush,
          cutBrush,
          HOLLOW_SUBTRACTION
        );
        mergedGeometry = BufferGeometryUtils.mergeGeometries(
          [crownMesh.geometry, rootMesh.geometry],
          true
        );
        mergedGeometry.center();
        let sCenter = toothMesh.stitchedBox.center;
        mergedGeometry.translate(sCenter.x, sCenter.y, sCenter.z);
        toothMesh.stitchedGeometry = fromBufferGeometry(mergedGeometry);
      }
      // toothMesh.material = materials;
    }
  });

  // vueApp.hasClosedBones = true;
}

function toBufferGeometry(geometry) {
  let bufferGeometry = null;
  if (geometry._bufferGeometry) bufferGeometry = geometry._bufferGeometry;
  else if (geometry.type == "BufferGeometry") {
    bufferGeometry = geometry;
  } else {
    bufferGeometry = new THREE.BufferGeometry().fromGeometry(geometry);
  }
  return bufferGeometry;
}

function fromBufferGeometry(bufferGeometry) {
  let tempGeo = new THREE.Geometry().fromBufferGeometry(bufferGeometry);
  tempGeo.mergeVertices();
  tempGeo.computeVertexNormals();
  let newGeometry = new THREE.BufferGeometry().fromGeometry(tempGeo);
  // newGeometry = BufferGeometryUtils.mergeVertices(newGeometry);
  // newGeometry.computeVertexNormals();
  return newGeometry;
}

function getToothCutBrush2(tooth) {
  const planeMat = new THREE.MeshBasicMaterial({
    color: 0xff0000,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.5,
    depthWrite: false,
  });

  let toothBox = tooth.defaultBox;
  let min = toothBox.min;
  let max = toothBox.max;
  let yDiff = toothBox.size.y / 2;
  // tooth.isUpper
  //   ? toothBox.size.y / 2
  //   : toothBox.size.y - toothBox.size.y / 1.5;
  toothBox = tooth.isUpper
    ? { min: { x: min.x, y: min.y + yDiff, z: min.z }, max: toothBox.max }
    : { min: toothBox.min, max: { x: max.x, y: max.y - yDiff, z: max.z } };
  toothBox = offsetBox(toothBox);

  let boxGeometry = new BoxGeometry(
    toothBox.size.x,
    toothBox.size.y,
    toothBox.size.z
  );
  boxGeometry.translate(
    toothBox.center.x,
    toothBox.center.y,
    toothBox.center.z
  );
  // let boxMesh = new THREE.Mesh(boxGeometry, planeMat);
  // viewer.scene.add(boxMesh);

  boxGeometry.computeVertexNormals();
  let cutBrush = new Brush(boxGeometry);
  cutBrush.updateMatrixWorld();

  return cutBrush;
}

function getToothCutBrush(tooth, toothMesh, bone, boneBrush) {
  const planeMat = new THREE.MeshBasicMaterial({
    color: 0xff0000,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.5,
    depthWrite: false,
  });

  let toothBox = tooth.defaultBox;
  let boxGeometry = new BoxGeometry(
    toothBox.size.x,
    toothBox.size.y,
    toothBox.size.z
  );
  boxGeometry.translate(
    toothBox.center.x,
    toothBox.center.y,
    toothBox.center.z
  );
  // let boxMesh = new THREE.Mesh(boxGeometry, planeMat);
  // viewer.scene.add(boxMesh);

  let boxBrush = new Brush(boxGeometry);
  boxBrush.updateMatrixWorld();

  const intersectMesh = csgEvaluator.evaluate(
    boxBrush,
    boneBrush,
    INTERSECTION
  );
  intersectMesh.material = planeMat;
  // viewer.scene.add(intersectMesh);

  let intersectGeometry = intersectMesh.geometry;
  intersectGeometry.computeVertexNormals();
  // let cutBrush1 = new Brush(intersectGeometry);
  // cutBrush1.updateMatrixWorld();
  // return cutBrush1;

  intersectGeometry.computeBoundingBox();
  toothBox = offsetBox(intersectGeometry.boundingBox);
  boxGeometry = new BoxGeometry(
    toothBox.size.x,
    toothBox.size.y,
    toothBox.size.z
  );
  boxGeometry.translate(
    toothBox.center.x,
    toothBox.center.y,
    // tooth.isUpper ? toothBox.center.y + 2 : toothBox.center.y - 2,
    toothBox.center.z
  );
  // let boxMesh = new THREE.Mesh(boxGeometry, planeMat);
  // viewer.scene.add(boxMesh);

  boxGeometry.computeVertexNormals();
  let cutBrush2 = new Brush(boxGeometry);
  cutBrush2.updateMatrixWorld();

  return cutBrush2;
}

function getFaces(geometry, mesh) {
  const faces = [];
  const index = geometry.index;
  if (index) geometry = geometry.toNonIndexed();
  geometry.computeVertexNormals();
  // console.log(geometry);
  const positionAttr = geometry.getAttribute("position");
  const normalAttr = geometry.getAttribute("normal");

  for (let i = 0; i < positionAttr.count; i += 3) {
    const face = {
      a: i,
      b: i + 1,
      c: i + 2,
    };
    face.indexes = [face.a, face.b, face.c];
    faces.push(face);
  }

  for (let j = 0; j < faces.length; j++) {
    let face = faces[j];
    face.normal = new THREE.Vector3(
      normalAttr.getX(face.a),
      normalAttr.getY(face.a),
      normalAttr.getZ(face.a)
    );
    face.pointA = new THREE.Vector3(
      positionAttr.getX(face.a),
      positionAttr.getY(face.a),
      positionAttr.getZ(face.a)
    );
    face.pointB = new THREE.Vector3(
      positionAttr.getX(face.b),
      positionAttr.getY(face.b),
      positionAttr.getZ(face.b)
    );
    face.pointC = new THREE.Vector3(
      positionAttr.getX(face.c),
      positionAttr.getY(face.c),
      positionAttr.getZ(face.c)
    );
    if (mesh) {
      face.pointA.applyMatrix4(mesh.matrixWorld);
      face.pointB.applyMatrix4(mesh.matrixWorld);
      face.pointC.applyMatrix4(mesh.matrixWorld);
    }
    face.pointA.index = face.a;
    face.pointB.index = face.b;
    face.pointC.index = face.c;
    // face.midPoint = new THREE.Vector3();
    // face.midPoint
    //   .copy(face.pointA)
    //   .add(face.pointB)
    //   .add(face.pointC)
    //   .multiplyScalar(1 / 3);

    let faceTriangle = new THREE.Triangle(
      face.pointA,
      face.pointB,
      face.pointC
    );
    // face.normal = new THREE.Vector3();
    // faceTriangle.getNormal(face.normal);
    // face.triangle = faceTriangle;
    face.area = faceTriangle.getArea();
  }

  return faces;
}

function filterFacesByDirection(faces, dir) {
  let filtered = [];
  const filter = -1;
  faces.forEach((face, index) => {
    let mult = new THREE.Vector3();
    mult.multiplyVectors(face.normal, dir);
    if (
      mult.x >= filter &&
      mult.y >= filter &&
      mult.z >= filter
      //  &&
      // (mult.x > 0 || mult.y > 0 || mult.z > 0)
    ) {
      filtered.push(face);
      // shapeArea += face.triangle.getArea();
    }
  });
  return filtered;
}

function facesToMesh(faces, color) {
  if (!color) {
    color = 0x00ff00;
  }
  let vertices = [];
  faces.forEach((face) => {
    let p0 = face.pointA; //face.points[0];
    let p1 = face.pointB; // face.points[1];
    let p2 = face.pointC; // face.points[2];
    vertices.push(
      p0.x,
      p0.y,
      p0.z, // vertex 1
      p1.x,
      p1.y,
      p1.z, // vertex 2
      p2.x,
      p2.y,
      p2.z // vertex 3
    );
  });

  let geometry = new THREE.BufferGeometry();
  geometry.setAttribute(
    "position",
    new THREE.BufferAttribute(new Float32Array(vertices), 3)
  );
  geometry.computeVertexNormals();
  const material = new THREE.MeshBasicMaterial({ color, wireframe: true });
  const mesh = new THREE.Mesh(geometry, material);
  return mesh;
}

function getMeshArea(mesh) {
  let area = 0;
  let geometry = mesh.geometry;
  if (!geometry.boundingBox) {
    geometry.computeBoundingBox();
  }
  let box = offsetBox(geometry.boundingBox);
  area =
    box.size.x * box.size.y * 2 +
    box.size.x * box.size.z * 2 +
    box.size.z * box.size.y * 2;
  area = (area / 100).toFixed(0); // Math.round(area * 100) / 100;
  return +area;
}

export {
  debugAnchorageResult,
  getMeshesBox,
  generateRootCrownMeshes,
  calculateAnchorAreas,
};
